import Masonry from "@mui/lab/Masonry";
import { Box, Skeleton, useMediaQuery } from "@mui/material";

// Fixed heights to prevent Masonry layout recalculation on every re-render
const DUMMY_HEIGHTS = [
  200, 170, 230, 160, 210, 180, 240, 155, 195, 225, 165, 215, 185, 245, 175, 205, 190, 235, 150,
  220,
];

const LoaderComponent = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  return (
    // <Grid container spacing={3}>
    //   {Array.from([1, 2, 3, 4, 5, 6]).map((index) => (
    //     <>
    //       <Grid
    //         key={index}
    //         item
    //         xs={12}
    //         sm={12}
    //         // md={folderMenuOpen ? 3 : 2.4}
    //         md={folderMenuOpen === "default" ? 3 : 4}
    //         sx={{ padding: "5px" }}>
    //         <Box
    //           className='skeleton skeleton-card'
    //           sx={{ height: { xs: "200px", sm: "250px" }, borderRadius: "5px" }}>
    //           <Skeleton variant='rectangular' width='100%' height='100%' />
    //         </Box>
    //       </Grid>
    //       <Grid
    //         key={`${index}-`}
    //         item
    //         xs={6}
    //         sm={6}
    //         md={folderMenuOpen === "default" ? 3 : 4}
    //         sx={{ padding: "5px" }}>
    //         <Box
    //           className='skeleton skeleton-card'
    //           sx={{ height: { xs: "200px", sm: "250px", borderRadius: "5px" } }}>
    //           <Skeleton variant='rectangular' width='100%' height='100%' />
    //         </Box>
    //       </Grid>
    //     </>
    //   ))}
    // </Grid>

    <Masonry
      columns={isSmallScreen ? 1 : 4}
      spacing={2}
      sx={{ margin: "4px" }}
      // className={classes.masonryGrid}
      // columnClassName={classes.masonryColumn}
    >
      {DUMMY_HEIGHTS.map((height, index) => (
        <Box key={index} sx={{ mb: 2 }}>
          <Skeleton
            variant='rectangular'
            animation='wave'
            sx={{
              height,
              borderRadius: 2,
              width: "100%",
            }}
          />
        </Box>
      ))}
    </Masonry>
  );
};

export default LoaderComponent;
